import WizardFooter from 'components/widgets/WizardFooter';
import Wizardable from 'components/widgets/Wizardable';
import PropTypes from 'prop-types';
import React from 'react';
import AddFutureItems from '../containers/AddFutureItems';
import { MetricFieldSchema } from '../types';
import { translationPrefix } from '../utils';
import FieldGroups from './FieldGroups';
import css from './MetricsSelection.css';

class MetricsSelection extends Wizardable {
    constructor(props) {
        super(props);

        this.buttonOverrides = props.wizardOverrideButtons;
    }

    render() {
        const { fields = [], onChange = () => {}, translate = () => {}, enableAddFuture = () => {} } = this.props;

        const allValues = fields.reduce((total, fieldType) => {
            total.push(...fieldType.values);
            return total;
        }, []);

        return (
            <>
                <this.AnimationItem pose="visible" className={css.page}>
                    <div>
                        <div className={css.headline}>
                            <div className={css.preamble}>
                                <div>Select metrics to be available for this user:</div>
                                <div className={css.faqLine}>
                                    For more information{' '}
                                    <a
                                        href="https://singular.zendesk.com/hc/en-us/articles/360020835952-Team-Management-FAQ"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        read the FAQ
                                    </a>
                                    .
                                </div>
                            </div>
                            <div className={css.selectorContainer}>
                                <div className={css.counter}>
                                    {translate(`${translationPrefix}.SELECTED_COUNT`, {
                                        selectedCount: allValues.filter(value => value.selected).length,
                                        totalCount: allValues.length,
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={css.contentArea}>
                        <FieldGroups
                            fields={fields}
                            allValues={allValues}
                            onChange={onChange}
                            enableAddFuture={enableAddFuture}
                        />
                    </div>
                </this.AnimationItem>
                <WizardFooter
                    buttons={this.getButtons()}
                    leftComponents={<AddFutureItems itemType="metrics" form="selectedMetrics" />}
                />
            </>
        );
    }
}

MetricsSelection.propTypes = {
    fields: PropTypes.arrayOf(MetricFieldSchema.isRequired).isRequired,
    onChange: PropTypes.func,
    translate: PropTypes.func,
};

export default MetricsSelection;
